<script>
  import { onMount } from 'svelte';
  import { httpsCallable } from 'firebase/functions';
  import { getFunctions } from 'firebase/functions';
    import { createEventDispatcher } from 'svelte';


 export let app;
 export let createIsMale;

  const functions = getFunctions(app);
  const dispatch = createEventDispatcher();

  let fileInput;  
  
  // Initialize Firebase functions
  const createChatFunction = httpsCallable(functions, 'createCustomChat');

  async function handleFileUpload(event) {
    const file = fileInput.files[0];  // Access files from fileInput instead of event
    if (file && file.type === 'application/json') {
      const reader = new FileReader();
      reader.onload = async () => {
        const json = JSON.parse(reader.result);
        const characterData = parseCharacterJson(json);
       // console.log("characterData");
      //  console.log(characterData);
        if (characterData) {
          dispatch('customChatInProcess');  // Dispatch the custom event
          const result = await createChatFunction(characterData);
        //  console.log(result);
        }
      };
      reader.readAsText(file);
    } else {
      console.error('Invalid file type. Please upload a JSON file.');
    }
  }

  function parseCharacterJson(json) {
    const charPersonaParts = json.char_persona.split('\n').map(line => line.trim());
    const physicalAttributesLine = charPersonaParts.find(line => line.startsWith('body'));

    let physicalAttributes;
    if (physicalAttributesLine) {
        physicalAttributes = physicalAttributesLine.split('(')[1].split(')')[0].replace(/\"/g, '').replace(/\s*\+\s*/g, ', ');
       // physicalAttributes = physicalAttributesLine ? physicalAttributesLine.split('(')[1].split(')')[0].replace(/\"/g, '').replace(/\s*\+\s*/g, ', ') : '';
    } else {
        // If physicalAttributesLine is not found, set physicalAttributes to the first sentence of char_persona
        const firstSentence = json.char_persona.match(/(.*?\.)/);
        physicalAttributes = firstSentence ? firstSentence[1] : '';
    }

    const talksLikeLines = json.example_dialogue.match(/{{char}}:.*?(\n|$)/g);
    const talksLike = talksLikeLines ? talksLikeLines.map(line => {
        const quotedText = line.match(/\"(.*?)\"/g);
        return quotedText ? quotedText.join(' ').replace(/\"/g, '') : '';
    }).join(' ') : '';

    const genderLine = charPersonaParts.find(line => line.startsWith('gender'));
    const gender = genderLine ? genderLine.split('(')[1].split(')')[0].replace(/\"/g, '') : null;
    if(gender) {
      if(gender == "male") {
        createIsMale = true;
       // console.log("custom male");
      } else {
        createIsMale = false;
       // console.log("custom female");
      }
    }

    let charStory = null;
    if(json.world_scenario && json.world_scenario != "") {
      charStory = json.world_scenario;
    } else {
      charStory = json.char_persona;
    }
    const characterData = {
      isMale: createIsMale,
      characterName: json.char_name,
      physicalAttributes,
      story: charStory,
      talksLike
    };

    return characterData;
  }


  let characterName = '';
  let physicalAttributes = '';
  let talksLike = '';
  let story = '';

  // Function to handle form submission
  async function handleFormSubmit() {
    if(characterName && characterName.trim() != "") {
      const characterData = {
        isMale: createIsMale,
        characterName,
        physicalAttributes,
        story,
        talksLike
      };

     // console.log("Submitted characterData:");
     // console.log(characterData);

      dispatch('customChatInProcess');  // Dispatch the custom event
      const result = await createChatFunction(characterData);
    //  console.log(result);
    }
  }

</script>

<div class="mt-6 p-4 text-xl font-bold border-b border-gray-500 flex justify-between items-center">
  Upload Pygmalion File
  <a href="https://botprompts.net" target="_blank" class="text-blue-500 text-base font-normal hover:underline">Examples</a>
</div>

<div class="p-4">
  <input type="file" accept=".json" class="mb-4 w-full border border-gray-300 p-2 rounded" bind:this="{fileInput}" placeholder="Select a .json file"/>
  <button class="bg-blue-500 text-white p-2 rounded w-full" on:click="{handleFileUpload}">Upload and Process</button>
</div>

<!-- Header for the Manual Entry section -->
<div class="p-4 text-xl font-bold border-b border-gray-500 mt-6">
  From Scratch
</div>

<div class="p-4">
  <form on:submit|preventDefault="{handleFormSubmit}">
    <div class="mb-4">
      <label for="characterName" class="block mb-2">Character Name:</label>
      <input type="text" id="characterName" bind:value="{characterName}" class="border p-2 rounded text-black" required />
    </div>
    <div class="mb-4">
      <label for="physicalAttributes" class="block mb-2">Physical Attributes:</label>
      <input type="text" id="physicalAttributes" bind:value="{physicalAttributes}" class="border p-2 rounded text-black w-full" required />
    </div>
    <div class="mb-4">
      <label for="talksLike" class="block mb-2">Talks Like:</label>
      <input type="text" id="talksLike" bind:value="{talksLike}" class="border p-2 rounded text-black w-full" required />
    </div>
    <div class="mb-4">
      <label for="story" class="block mb-2">Story:</label>
      <textarea id="story" bind:value="{story}" class="border p-2 rounded text-black w-full" rows="3" required></textarea>
    </div>
    <button type="submit" class="bg-blue-500 text-white p-2 rounded">Submit and Process</button>
  </form>
</div>